module.exports = __webpack_public_path__ + "img/logo_v3.a27d98fc.png";